export default __webpack_public_path__ + "static/media/square.8f6c94d0.svg";